import "./intro.css";
import person from "./img/person2.png"
import { useEffect } from "react";

export default function Intro () {
    useEffect(() => {
        const saluteTextContainer = document.querySelector('.saluteTextContainer')
        const saluteTextContainerMobile = document.querySelector('.saluteTextContainerMobile')
        const saluteImgContainer = document.querySelector('.saluteImgContainer')
        const authorName = document.querySelector('.name')
        const jobTitleContainers = document.querySelectorAll('.jobTitleContainer')
        const jobTitles = document.querySelectorAll('.jobTitle')
       
        window.addEventListener("scroll", ()=>{
            let offsetY = window.scrollY;
        
            const heightSalute = document.querySelector('.salute').clientHeight;
            const heightNameContainer = document.querySelector('.nameContainer').clientHeight;
            const heightJobTitleContainerDark = jobTitleContainers[0].clientHeight;
            
            const offsetAuthorName = heightSalute-offsetY;
            const offsetYJobTitleDark = heightSalute+heightNameContainer-offsetY;
            const offsetYJobTitlePurple = heightSalute+heightNameContainer+heightJobTitleContainerDark-offsetY;
            
            saluteTextContainer.style.transform=`translateY(${offsetY*0.5}px)`
            saluteTextContainerMobile.style.transform=`translateY(${offsetY*0.85}px)`
            saluteImgContainer.style.transform=`translate(${offsetY*0.4}px, ${offsetY*0.7}px)`
            authorName.style.transform=`translateX(${offsetAuthorName*0.2}px)`;
            jobTitleContainers[0].style.backgroundPositionY=`${offsetY*0.5}px`;
            jobTitleContainers[1].style.backgroundPositionY=`${-offsetY*0.5}px`;
            jobTitles[0].style.transform=`translateX(${-offsetYJobTitleDark}px)`;
            jobTitles[1].style.transform=`translateX(${offsetYJobTitlePurple}px)`;
        })
    }, []);
    return(
        <div className="intro">
            <div className="salute">
                <div className="saluteTextContainer">
                    <h1 className="saluteText">Hello!</h1>
                </div>
                <div className="saluteTextContainerMobile">
                    <h1 className="saluteTextMobile">Hello!</h1>
                </div>
                <div className="saluteImgContainer">
                    <img src={person} alt="salute img" className="saluteImg"></img>
                </div>
                

            </div>
            <div className="nameContainer">
                <h2 className="name">I’m Myroslav</h2>
            </div>
            <div className="jobTitleContainer dark">
                <h2 className="jobTitle">a FullStack Developer</h2>
            </div>
            <div className="jobTitleContainer purple">
                <h2 className="jobTitle">and Designer</h2>
            </div>

            
        </div>
    )
}
